// extracted by mini-css-extract-plugin
export default {"wrapper":"UpgradeBadge-module__wrapper--SOEN0","boltIcon":"UpgradeBadge-module__boltIcon--NtOEm"};